import { axiosInstance } from '@/utils/axiosInstance';

/**
 * CMS Tooltips (Tip Cards) API client
 *
 * Spec defined in cms-new-store/FRONTEND_TOOLTIPS.md
 *
 * GET /api/cms/tooltip?profileId=123
 * Base URL (dev): http://localhost:3000
 * Base URL (prod): to be defined – configured via env var.
 */

// Sections exposed by the CMS tooltips API
export type CmsTooltipSection = 'express' | 'para-voce' | 'outros';

export interface ICmsTooltip {
  id: number;
  title: string | null;
  text: string;
  section: CmsTooltipSection;
  is_first_in_section: boolean;
  priority: number;
  frequency_every_x_cards: number | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

// Using a fixed base URL for the CMS tooltips endpoint (ignoring env vars)
const CMS_TOOLTIPS_URL =
  'https://cms-new-store-654142862275.us-central1.run.app/api/cms/tooltip';

export const CmsTooltipsService = {
  /**
   * Fetch active, non-dismissed tip cards for a given profile.
   *
   * The backend already applies:
   * - is_active = true
   * - dismissed = false (or no status record)
   * - ordering by section, is_first_in_section, priority, id
   */
  getTooltips: async (
    profileId: number,
  ): Promise<ICmsTooltip[]> => {
    const request = {
      method: 'GET',
      url: `${CMS_TOOLTIPS_URL}?profileId=${profileId}`,
    };

    const res = await axiosInstance<ICmsTooltip[]>(request);

    return res.data;
  },
};

